import React from 'react'
import { MwButton, MwSpinnerButton, NoDataFound } from '../ui'
import LineChart from '../charts/LineChart'
import { Link } from 'react-router-dom'

const MonthlyLineChart = ({
    tenantUsername,
    loading,
    monthlyList,
    label
}) => {
    return (
        <div className="h-full flex flex-col">
            {loading ? (
                <div className="flex-1 flex items-center justify-center">
                    <MwSpinnerButton isFullCenter={true} withLabel={false} />
                </div>
            ) : monthlyList.length > 0 ? (
                <div className="flex-1">
                    <LineChart
                        label={label}
                        datasetData={monthlyList}
                        loading={loading}
                    />
                </div>
            ) : (
                <div className="flex-1 flex items-center justify-center border-2 border-dashed border-slate-100 rounded-3xl">
                    <NoDataFound msg={`لا يوجد تذاكر دعم حالياً`}>
                        <div className='flex gap-3 justify-center items-center mt-4'>
                            <Link to={`/${tenantUsername}/tickets/add`}>
                                <MwButton classNameCustom="px-6 py-2.5 rounded-xl font-bold">
                                    إنشاء تذكرة دعم جديدة
                                </MwButton>
                            </Link>
                        </div>
                    </NoDataFound>
                </div>
            )}
        </div>
    )
}

export default MonthlyLineChart
